import '../base/minified/introjs.min.css';
import '../base/minified/introjs-rtl.min.css';
import './index.less';



// WEBPACK FOOTER //
// ./ecology9/wea-intro/style/index.js